import { appColors, Tier } from '@backrs_ui/common-ui';

import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';

import { Box, Typography, SxProps, Theme } from '@mui/material';

type MinimumTrackHeaderProps = Readonly<{
  minimumTrack: Tier;
}>;

export const MinimumTrackHeader = ({ minimumTrack }: MinimumTrackHeaderProps) => {
  return (
    <Box sx={minimumTrackHeaderStyle}>
      <Typography variant="body1" color={appColors.color.blue1}>
        {appStrings.modules.results.minimumTrackTitle}
      </Typography>
      <Typography variant="h4" sx={minimumTrackTitleStyle}>
        {minimumTrack}
      </Typography>
    </Box>
  );
};

const minimumTrackHeaderStyle: SxProps<Theme> = {
  backgroundColor: appColors.neutral.white,
  border: `2px solid ${appColors.neutral.black}`,
  borderRadius: '.5rem',
  paddingX: {
    xs: '1rem',
    sm: '2rem',
  },
  paddingTop: '1rem',
  paddingBottom: {
    xs: '1.5rem',
    sm: '1.75rem',
  },
  height: 'auto', // Allow dynamic growth
  boxSizing: 'border-box', // Include padding in height calculations
  '&::after': {
    content: '""', // Empty block for alignment
    display: 'block',
    height: '0',
    marginTop: 'calc(28px - (100% % 28px))', // Adjust height to the nearest multiple of 28px
  },
};

const minimumTrackTitleStyle: SxProps<Theme> = {
  fontSize: {
    xs: '16pt',
    sm: '24pt',
  },
  fontWeight: 'bold',
};
